import React, { useState } from 'react'
import clsx from 'clsx'

import { Image } from '@/components/atoms/Image/Image'
import PlayIcon from '@/assets/icons/play-button.svg'
import * as styles from './Video.module.css'

export function Video({ thumbnail, url, inCard }: VideoTypes) {
  const [hideThumbnail, setHideThumbnail] = useState(false)

  const showVideo = () => setHideThumbnail(true)

  function handleYoutubeAutoPlay(videoUrl: string) {
    if (videoUrl.includes('autoplay=1')) return videoUrl
    if (videoUrl.includes('?')) return `${videoUrl}&autoplay=1`

    return `${videoUrl}?autoplay=1`
  }

  return (
    <div className="relative w-full overflow-hidden mb-24">
      <div
        className={clsx(
          styles.thumbnailHolder,
          'h-auto overflow-hidden transition-opacity ease-in-out duration-300 cursor-pointer',
          hideThumbnail ? 'absolute opacity-0' : 'relative opacity-100'
        )}
        onClick={showVideo}
        aria-hidden="true"
      >
        {thumbnail && (
          <Image
            fluid
            fixed={false}
            data={thumbnail}
            options={{ width: 400, maxWidth: 600 }}
            className="w-full h-full z-8 !absolute top-0 left-0"
          />
        )}
        <div
          className={clsx(
            styles.btnHolder,
            'absolute inset-1/2 w-96 h-96 tablet:w-144 tablet:h-144 transform -translate-x-1/2 -translate-y-1/2',
            'rounded-full flex justify-center items-center pl-10 netbook:pl-16',
            inCard && 'tablet:w-128 tablet:h-128'
          )}
        >
          <img src={PlayIcon} alt="play-button" width="50%" />
        </div>
      </div>

      {hideThumbnail && (
        <div className={clsx(styles.frameContainer, 'relative w-full block')}>
          <iframe
            allowFullScreen
            width="100%"
            height="400px"
            src={handleYoutubeAutoPlay(url)}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            className="absolute top-0 left-0 w-full h-full z-5"
          />
        </div>
      )}
    </div>
  )
}
